import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// solid
import {
	faDraftingCompass as fasDraftingCompass,
	faFillDrip as fasFillDrip,
	faHeartbeat as fasHeartbeat,
	faBoneBreak as fasBoneBreak,
	faPoop as fasPoop,
	faLungs as fasLungs,
	faHands as fasHands,
	faSocks as fasSocks,
	faCogs as fasCogs,
	faUmbrella as fasUmbrella,
	faBong as fasBong,
	faBandAid as fasBandAid,
	faStarOfLife as fasStarOfLife,
	faSeedling as fasSeedling,
	faFeather as fasFeather,
	faMagic as fasMagic,
	faDiagnoses as fasDiagnoses,
	faThermometerEmpty as fasThermometerEmpty,
	faWalking as fasWalking,
	faBolt as fasBolt,
	faWheelchair as fasWheelchair,
	faCapsules as fasCapsules,
	faRobot as fasRobot,
	faInhaler as fasInhaler,
	faCarrot as fasCarrot,
	faDumbbell as fasDumbbell,
	faFootballHelmet as fasFootballHelmet,
	faProcedures as fasProcedures,
	faBrain as fasBrain,
} from '@awesome.me/kit-012d1b9af0/icons/classic/solid';

// regular
import { faHeadSideBrain as farHeadSideBrain } from '@awesome.me/kit-012d1b9af0/icons/classic/regular';

// light
import {
	faAtomAlt as falAtomAlt,
	faEye as falEye,
	faUser as falUser,
	faRoute as falRoute,
	faMapPin as falMapPin,
} from '@awesome.me/kit-012d1b9af0/icons/classic/light';

library.add(
	fasDraftingCompass,
	fasFillDrip,
	fasHeartbeat,
	fasBoneBreak,
	fasPoop,
	fasLungs,
	fasHands,
	fasSocks,
	fasCogs,
	fasUmbrella,
	fasBong,
	fasBandAid,
	fasStarOfLife,
	fasSeedling,
	fasFeather,
	fasMagic,
	fasDiagnoses,
	fasThermometerEmpty,
	fasWalking,
	fasBolt,
	fasWheelchair,
	fasCapsules,
	fasRobot,
	fasInhaler,
	fasCarrot,
	fasDumbbell,
	fasFootballHelmet,
	fasProcedures,
	fasBrain,
	farHeadSideBrain,
	falAtomAlt,
	falEye,
	falUser,
	falRoute,
	falMapPin
);

export default FontAwesomeIcon;
